// extracted by mini-css-extract-plugin
module.exports = {"displayField":"displayField_displayField__1ft1V","label":"displayField_label__2kPEo","value":"displayField_value__3zhgw"};